import { render, staticRenderFns } from "./matching-schedule.vue?vue&type=template&id=13a7a39c"
import script from "./matching-schedule.vue?vue&type=script&lang=js"
export * from "./matching-schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports